import axios from "axios";

export default async function useGetUserBySession(session: string) {
    try {
        const response = await axios.post(
            process.env.REACT_APP_GET_USER_ENDPOINT || "",
            { session }
        );

        if (response.status >= 200 && response.status < 300) {
            return response.data.response.session;
        } else {
            throw new Error("Invalid session")
        }
    } catch (error) {
        throw new Error("Invalid session")
    }
}
